import { render, staticRenderFns } from "./SwitcherView.vue?vue&type=template&id=a9a45c40&scoped=true"
import script from "./SwitcherView.vue?vue&type=script&lang=js"
export * from "./SwitcherView.vue?vue&type=script&lang=js"
import style0 from "./SwitcherView.vue?vue&type=style&index=0&id=a9a45c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a45c40",
  null
  
)

export default component.exports